import axios from "axios";

const API_BASE_URL = "https://kintoneconnect-qdbwxdfcvq-an.a.run.app/api";
const apiClient = axios.create({
  // baseURL: "http://localhost:5000/api",
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
